class ProductsSlider extends HTMLElement {
  constructor() {
    super();

    this.track = this.querySelector('.products-slider__wrapper');
    this.paginationContainer = this.querySelector('.products-slider__pagination');
    this.slides = Array.from(this.querySelectorAll('.products-slider__slide'));
    this.isDown = false;
    this.isDragging = false;
    this.startX = 0;

    this.startScrollPosition = 0;

    this.initCarousel();
  }

  initCarousel() {
    if (!this.track) return;

    this.setupPagination();
    this.track.addEventListener('scroll', () => this.updatePaginationActiveState());
    window.addEventListener('resize', () => {
      this.setupPagination();
      this.updatePaginationActiveState();
    });

    this.track.addEventListener('dragstart', (e) => e.preventDefault());

    this.track.addEventListener('click', (e) => {
      if (this.isDragging) {
        e.preventDefault();
        e.stopPropagation();
      }
    });

    this.track.addEventListener('mousedown', (e) => this.handleDragStart(e));
    this.track.addEventListener('mouseleave', () => this.handleDragEnd());
    this.track.addEventListener('mouseup', () => this.handleDragEnd());
    this.track.addEventListener('mousemove', (e) => this.handleDragMove(e));
  }

  getSlidesPerView() {
    return window.innerWidth >= 640 ? 4 : 2;
  }

  setupPagination() {
    if (!this.paginationContainer) return;
    this.paginationContainer.innerHTML = '';

    const totalSlides = this.slides.length;
    const slidesPerView = this.getSlidesPerView();

    let pageCount = totalSlides - slidesPerView + 1;
    if (pageCount < 1) pageCount = 1;

    this.paginationContainer.style.display = pageCount <= 1 ? 'none' : 'flex';

    for (let i = 0; i < pageCount; i++) {
      const dot = document.createElement('div');
      dot.classList.add('products-slider__pagination-bullet');
      if (i === 0) dot.classList.add('active');

      dot.addEventListener('click', () => {
        this.scrollToPage(i);
      });

      this.paginationContainer.appendChild(dot);
    }
  }

  updatePaginationActiveState() {
    if (!this.paginationContainer || !this.track || this.slides.length === 0) return;

    const gap = window.innerWidth >= 640 ? 20 : 15;
    const singleSlideWidth = this.slides[0].offsetWidth + gap;

    let currentPage = Math.round(this.track.scrollLeft / singleSlideWidth);

    const dots = this.paginationContainer.querySelectorAll('.products-slider__pagination-bullet');
    dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === currentPage);
    });
  }

  scrollToPage(pageIndex) {
    if (this.slides.length === 0) return;

    const gap = window.innerWidth >= 640 ? 20 : 15;
    const singleSlideWidth = this.slides[0].offsetWidth + gap;
    const scrollAmount = pageIndex * singleSlideWidth;

    this.track.style.scrollSnapType = 'none';
    this.track.scrollTo({
      left: scrollAmount,
      behavior: 'smooth',
    });

    setTimeout(() => {
      this.track.style.scrollSnapType = '';
    }, 500);
  }

  handleDragStart(e) {
    this.isDown = true;
    this.isDragging = false;

    const currentScroll = this.track.scrollLeft;

    this.track.style.scrollSnapType = 'none';
    this.track.style.scrollBehavior = 'auto';
    this.track.style.cursor = 'grabbing';

    this.startX = e.pageX - this.track.offsetLeft;

    this.startScrollPosition = currentScroll;

    this.track.scrollLeft = this.startScrollPosition;
  }

  handleDragEnd() {
    this.isDown = false;
    this.track.style.scrollSnapType = '';
    this.track.style.scrollBehavior = 'smooth';
    this.track.style.cursor = 'grab';

    setTimeout(() => {
      this.isDragging = false;
    }, 50);
  }

  handleDragMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.track.offsetLeft;
    const walk = x - this.startX;

    if (Math.abs(walk) > 5) {
      this.isDragging = true;
    }

    this.track.scrollLeft = this.startScrollPosition - walk;
  }
}

if (!customElements.get('products-slider')) {
  customElements.define('products-slider', ProductsSlider);
}
